import { render, staticRenderFns } from "./StatesTable.vue?vue&type=template&id=70bf3aff&scoped=true"
import script from "./StatesTable.vue?vue&type=script&lang=js"
export * from "./StatesTable.vue?vue&type=script&lang=js"
import style0 from "./StatesTable.vue?vue&type=style&index=0&id=70bf3aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf3aff",
  null
  
)

export default component.exports